import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../../styles/materialButtonStyle";
import ServicesSelect from "../../../elements/services/ServicesSelect";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import ProjectsSelect from "../../../elements/projects/ProjectsSelect";

const RatesFilter = ({ filterData, setFilterData, userId }) => {
  const { t } = useTranslation("clientsPage");
  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"],
    "rateBase.currency.asset": "",
    "rateBase.service.name": null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("details.rate.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.rate.filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="asset">{t("details.rate.filter.asset")}</label>
              <DelayInput
                id="asset"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "rateBase.currency.asset": event.target.value,
                  page: 1
                })}
                name="asset"
                value={filterData["rateBase.currency.asset"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledSelectGroup>
              <ProjectsSelect
                checkedProjects={filterData["connection.project.name"]}
                setCheckedProjects={(data) => setFilterData({
                  ...filterData,
                  "connection.project.name": data,
                  page: 1
                })}
                isObject={false}
                defaultOption={true}
                userId={userId}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <ServicesSelect
                checkedService={filterData["connection.service.name"]}
                setCheckedService={(data) => setFilterData({ ...filterData, "connection.service.name": data, page: 1 })}
                isObject={false}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <ServicesSelect
                checkedService={filterData["rateBase.service.name"]}
                setCheckedService={(data) => setFilterData({ ...filterData, "rateBase.service.name": data, page: 1 })}
                isObject={false}
                defaultOption={true}
                rateService={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("details.rate.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default RatesFilter;